const state = {
   dockSuggestions: {},
}

export default state
